import { COMPANY } from "../data/company";
import { LegalLayout } from "../components/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout
      title="Politica de cookies"
      subtitle="Folosim cookies pentru a-ți oferi o experiență optimă pe site."
      lastUpdated="Februarie 2026"
    >
      <h2 className="font-heading text-xl font-bold text-slate-900">Ce sunt cookies?</h2>
      <p>
        Cookies sunt fișiere text de mici dimensiuni stocate de browser pe
        dispozitivul tău atunci când vizitezi un site web. Ele permit site-ului
        să-și amintească preferințele tale și să-ți ofere o experiență
        personalizată.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">Tipurile de cookies pe care le folosim</h2>

      <h3 className="font-heading text-lg font-bold text-slate-900 mt-4">
        1. Cookies strict necesare (esențiale)
      </h3>
      <p>
        Aceste cookies sunt indispensabile funcționării site-ului. Fără ele nu
        poți utiliza coșul de cumpărături sau alte funcționalități de bază.
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>dd_cart_v1</strong> — păstrează produsele din coșul tău
          (localStorage)
        </li>
        <li>
          <strong>dd_cookie_consent_v1</strong> — memorează preferința ta de
          cookies
        </li>
      </ul>

      <h3 className="font-heading text-lg font-bold text-slate-900 mt-4">
        2. Cookies de analiză (opționale)
      </h3>
      <p>
        Ne ajută să înțelegem cum utilizezi site-ul, pentru a-l îmbunătăți. Nu
        colectează informații de identificare personală.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">Cum poți controla cookies?</h2>
      <p>Poți gestiona cookies în mai multe moduri:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Folosește banner-ul de cookies afișat la prima vizită pentru a alege
          ce accepți
        </li>
        <li>
          Modifică setările browser-ului tău (Chrome, Firefox, Safari, Edge)
          pentru a bloca sau șterge cookies
        </li>
        <li>
          Șterge istoricul navigării pentru a elimina toate cookies stocate
        </li>
      </ul>
      <p className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-amber-900 text-sm">
        ⚠️ Blocarea cookies-urilor esențiale poate afecta funcționarea
        site-ului (ex: coșul de cumpărături nu va mai funcționa).
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">Contact</h2>
      <p>
        Pentru întrebări despre această politică, contactează-ne la{" "}
        <a href={`mailto:${COMPANY.email}`} className="text-cyan-600 underline">
          {COMPANY.email}
        </a>
        .
      </p>
    </LegalLayout>
  );
}
